import Header from '../components/Header'
import SearchBar from '../components/search/SearchBar'
import Footer from '../components/Footer'
import Home from '../components/Home'

export default function HomePage () {
  return (
    <>
      <Header/>
      <SearchBar/>
      <Home/>
      <Footer absolute={true}/>
    </>
  )
}